import { useCallback } from 'react';
import { useCreateDeal } from './mutations/useCreateDeal';
import { JourneyType } from '../../__generated__/globalTypes';
import dealStorageService from '../../../../common/service/dealStorageService';
import useWidgetContext from '../../common/react/useWidgetContext';
import { constants } from '../../../../common/constants/constants';
import { IActionButtonsDisplayConfig } from '../components/customiseContainer/actionButtons/ActionButtonsContainer';

export const useRequestUrl = () => {
  const {
    configuration: { dimensions },
  } = useWidgetContext();
  const { createNewDeal } = useCreateDeal();

  const getRequestQuoteUrl = useCallback(
    async (config: IActionButtonsDisplayConfig, journeyType: JourneyType) => {
      const { TOKEN } = constants;
      const { requestQuoteUrl, reserveOnlineUrl } = config;
      let baseRequestUrl = journeyType === JourneyType.continue_in_dealership ? requestQuoteUrl : reserveOnlineUrl;
      if (config.isCheckout4Enabled) {
        baseRequestUrl = config.checkoutUrl;
      }
      const createDealResponse = await createNewDeal(journeyType);
      const dealData = createDealResponse.data.createDealFromCarId;
      dealStorageService.saveDeal(dimensions, JSON.stringify(dealData));
      const dealId = dealData.uuid;
      const queryParams: string[] = [`${TOKEN}=${dealId}`];
      const url = `${baseRequestUrl}?${queryParams.join('&')}`;

      return { dealId, url };
    },
    [dimensions, createNewDeal],
  );

  return { getRequestQuoteUrl };
};
